export const categoryIntercomArticles = [
  {
    link: 'https://help.vaultplatform.com/en/articles/8949978-how-to-create-and-update-a-category',
    title: 'How to set up and update categories',
  },
  {
    link: 'https://help.vaultplatform.com/en/articles/6638099-what-is-vault-platform',
    title: `Vault's intake methods`,
  },
];

export const routingIntercomArticles = [
  {
    link: 'https://help.vaultplatform.com/en/articles/8857061-what-are-groups',
    title: 'What are "Groups"?',
  },
  {
    link: 'https://help.vaultplatform.com/en/articles/8856566-how-do-i-route-reports-to-case-managers',
    title: 'What is "Routing"?',
  },
];

export const addingFilesAsEvidenceIntercomArticle =
  'https://help.vaultplatform.com/en/articles/9231242-adding-files-as-evidence';

export const tagsIntercomArticle = [
  {
    link: 'https://help.vaultplatform.com/en/articles/9956493-how-to-create-and-use-tags',
    title: `How to create and use tags`,
  },
];

export const sanitationInfoIntercomArticle =
  'https://help.vaultplatform.com/en/articles/11993238-saving-a-copy-of-your-report';
